import React from 'react'
import { Route } from 'react-router-dom'

import Account from './containers/Account'
import ChangePassword from './containers/ChangePassword'
import ConfirmPayment from './containers/ConfirmPayment'
import Event from './containers/Event'
import Events from './containers/Events'
import Login from './containers/Login'
import MyOrder from './containers/MyOrder'
import OrderEvent from './containers/OrderEvent'
import EditOrder from './containers/OrderEvent/editOrder'
import OrderSummary from './containers/OrderSummary'
import Participant from './containers/Participant'
import Payment from './containers/Payment/index'
import Profile from './containers/Profile'
import Race from './containers/Race'
import Races from './containers/Races'
import Ranking from './containers/Ranking'
import RegisterRace from './containers/RegisterRace/'
import EditParticipant from './containers/RegisterRace/editParticipant'
import ResetPassword from './containers/ResetPassword'
import RunStatus from './containers/RunStatus'
import Signup from './containers/Signup'
import PastRaces from './containers/PastRaces'
import SubmitRun from './containers/SubmitRun'
import MyMedal from './containers/MyMedal'
import ThankYou from './containers/Thankyou'
import AboutUs from './containers/AboutUs'

export default () => (
  <div style={{ minHeight: '100px' }}>
    <Route exact path="/" component={Races} />
    <Route exact path="/edit-account" component={Account} />
    <Route exact path="/races" component={Races} />
    <Route exact path="/past-races" component={PastRaces} />
    <Route exact path="/my-medals" component={MyMedal} />
    <Route exact path="/races/:slug" component={Race} />
    <Route exact path="/events/" component={Events} />
    <Route exact path="/events/:slug" component={Event} />
    <Route exact path="/events/:slug/order" component={OrderEvent} />
    <Route
      exact
      path="/participants/:id/payment/thank-you"
      component={ThankYou}
    />
    <Route exact path="/my-order/" component={MyOrder} />
    <Route exact path="/orders/:id" component={OrderSummary} />
    <Route exact path="/orders/:id/edit" component={EditOrder} />
    <Route exact path="/participants/payment/:id" component={Payment} />
    <Route exact path="/participants/:id/edit" component={EditParticipant} />
    <Route exact path="/participants/:id" component={Participant} />
    <Route exact path="/me/" component={Profile} />
    <Route path="/races/:slug/register" component={RegisterRace} />
    <Route path="/races/:slug/ranking" component={Ranking} />
    <Route path="/confirm-payment" component={ConfirmPayment} />
    <Route path="/submit-run" component={SubmitRun} />
    <Route path="/run-status" component={RunStatus} />
    <Route exact path="/signup" component={Signup} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/change-password" component={ChangePassword} />
    <Route exact path="/about-us" component={AboutUs} />
  </div>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/Routes.js